<template>
  <div>
    <div class="superuser-anonymous-order-return__top">
      <validation-observer
        ref="superuserProductSearchForm"
        tag="form"
        class="superuser-anonymous-order-return__form"
        @submit.prevent
        @keyup.enter="orderReturn()">
        <validation-provider v-slot="{errors}" rules="required" slim>
          <oie-base-input
            id="orderNumber"
            v-model="orderNumber"
            :label-text="'Ordernummer'"
            :placeholder="'Anonyma kundens ordernummer'"
            :error-messages="errors"
            class="superuser-anonymous-order-return__input"></oie-base-input>
        </validation-provider>
        <oie-base-button
          v-element-loader="{ endpoint: 'superuser/product/search' }"
          css-classes="button--with-border button--blue superuser-importsearch__action"
          text="Retur"
          @click="orderReturn()"></oie-base-button>
      </validation-observer>
    </div>
  </div>
</template>

<script>

export default {
  data: () => ({
    orderNumber: null,
    productRows: null
    // existingCustomers: null,
    // erpCustomer: null,
    // erpCustomerImported: null,
    // skipClearState: false
  }),
  computed: {
  },

  mounted() {
  },
  methods: {
    async orderReturn() {
      const isValid = await this.$refs.superuserProductSearchForm.validate()

      if (!isValid) {
        return
      }

      window.location.href = this.clientModel.orderReturnUrl + '?orderNumber=' + this.orderNumber
    }
  }
}
</script>

<style lang="scss">
  .superuser-anonymous-order-return__top {
    display: flex;
    flex-direction: column;
    margin-bottom: measure(full);

    @include media(medium) {
      flex-direction: row;
    }
  }

  .superuser-anonymous-order-return__form {
    display: flex;
    flex-direction: column;
    width: 100%;
    order: 1;

    @include media(small) {
      flex-direction: row;
      max-width: 30rem;
    }

    @include media(medium) {
      order: initial;
    }
  }

  .superuser-anonymous-order-return__input {
    margin-bottom: measure(quarter);

    @include media(small) {
      margin-bottom: 0;
      margin-right: measure(half);
    }
  }
</style>
